export const ValidateField = (input) => {
  const selector = '#' + input.id + ' + span.error';
  const inputError = document.querySelector(selector);

  //console.log('input', input, input.validity, input.validity.valid)
  if (input.validity.valid) {
    inputError.innerText = '';
    inputError.className = 'error';

    if (input.type == 'password') {
      //make sure passwords match
      const confirmpassword = document.querySelector('#confirmPassword');
      const password = document.querySelector('#password');

      if (confirmpassword) {
        if (password.value !== confirmpassword.value) {
          inputError.innerText = 'Passwords must match';
          inputError.className = 'error active';
        } else {
          inputError.innerText = '';
          inputError.className = 'error';

          const otherPasswordId =
            input.id === 'confirmPassword' ? password.id : confirmpassword.id;
          //reset other error field
          const selector = '#' + otherPasswordId + ' + span.error';
          const otherPassword = document.querySelector(selector);
          otherPassword.innerText = '';
          otherPassword.className = 'error';
        }
      }
    }

    return;
  }

  if (input.validity.typeMismatch) {
    inputError.innerText = 'You must enter a valid email address';
  } else if (input.validity.tooShort) {
    inputError.innerText = `Value needs to be at least ${input.minLength} characters`;
  } else if (input.validity.patternMismatch) {
    inputError.innerText =
      'Value must contain at least one character and one number';
  }

  inputError.className = 'error active';
};
